module.exports = __webpack_public_path__ + "/img/8e70ad26b48ed4806cdccb707be2c9de.png";